import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export async function listPatients(token: string, q?: string, limit=25, offset=0) {
  const res = await axios.get(`${API}/patients`, {
    params: { q: q || undefined, limit, offset },
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data as any[];
}
export async function createPatient(token: string, body:{
    // patientId:string;
    givenName: string;
    familyName: string;
    dateOfBirth?: string|null;
    sex?: string|null;
    notes?: string|null;
}){
    const res = await axios.post(`${API}/patients`, body, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
}

export async function updatePatient(token: string, patientId:string, body:{
    givenName?: string;
    familyName?: string;
    dateOfBirth?: string|null;
    sex?: string|null;
    notes?: string|null;
}){
    const res = await axios.put(`${API}/patients/${patientId}`, body, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
}

export async function deletePatient(token: string, patientId:string){
    const res = await axios.delete(`${API}/patients/${patientId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
}



// With Cases 

export async function listPatientCases(token: string, patientId: string, limit=10, offset=0) {
  const res = await axios.get(`${API}/patients/${encodeURIComponent(patientId)}/cases`, {
    params: { limit, offset },
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data as Array<{ id: string; caseId: string; fileName?: string; mimeType?: string; createdAt?: string; }>;
}

